module.exports = __webpack_public_path__ + "img/icon_menu_sp_uriage1.047caa3d.png";